import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { ManageVersion } from '../modal';

export default function reducer(state: ManageVersion = new ManageVersion(), action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.MANAGE_VERSION_LIST_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.MANAGE_VERSION_LIST_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.MANAGE_VERSION_LIST_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
